export default __webpack_public_path__ + "static/media/arrow-down-grey.4fcf608d.svg";